import { Main } from './components';

export const Topups = () => {
    return <Main />;
};

